  <!--
   功能名称:千里眼平台(技师)-我的
   开发人:梁高权
   创建时间:2021/03/14
   最后修改时间:2021/03/14
   -->
<template>
  <div class="me-wrap">
    <div class="bg"></div>
    <div class="content">
      <div class="my">
        <div>
          <img v-lazy="userStatus.head_img">
          <div>
            <h5>{{userStatus.nickname|stringFormat}}</h5>
            <i>{{userStatus.phone}}</i>
          </div>
        </div>
        <!-- <van-icon name="arrow" color="#fff" size='15px' /> -->
      </div>
      <ul class="message">
        <li>
          <span>{{meData.staff_work_no}}号</span>
          <i>工号</i>
        </li>
        <li>
          <span>{{shopNameTitle}}</span>
          <i>门店</i>
        </li>
        <li>
          <span>{{meData.staff_profit}}元</span>
          <i>收益</i>
        </li>
      </ul>
      <ul class=" functionList">
        <li style="filter: grayscale(100%);opacity:0.5">
          <img src="@/assets/images/steward-icon.png">
          <span>我的管家</span>
        </li>
        <li style="filter: grayscale(100%);opacity:0.5">
          <img src="@/assets/images/target-icon.png">
          <span>我的目标</span>
        </li>
        <li @click="$router.push('remindSet')">
          <img src="@/assets/images/set-icon.png">
          <span>提醒设置</span>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import table from '@/api/table'
import {mapState} from 'vuex'
export default {
  name: 'me',
  data () {
    return {
      shopNameTitle:localStorage.getItem('shopNameTitle'),
      meData:new Object()
    }
  },
  computed: {
    ...mapState(['userStatus'])
  },
  filters:{
    // 格式化字符
    stringFormat(val){
      let a='';if(val.length>10){a=val.substring(0,10)+'...'}else{a=val}
      return a
    }
  },
  mounted () {
    this.centerIndex()
  },
  methods: {
    centerIndex(){
      table.centerIndex().then(response=>{
        this.meData=response.data.list
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .me-wrap {
    position:relative;
    .bg{
      height: 420px;
      width: 100%;
      position: absolute;
      top: 0;
      background: url("~@/assets/images/achievement-Bg.png") no-repeat top/100%;
      background-position:0 -435px;
    }
    .content{
      position: relative;
      .my{
        padding: 50px 60px 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        >div{
          display: flex;
          align-items: center;
          >img{
            width: 120px;
            height: 120px;
            border-radius: 50%;
            border: 1px solid #fff;
            margin-right: 35px;
          }
          >div{
            font-size: 34px;
            font-weight: bold;
            color: #fff;
            h5{
              line-height: 75px;
            }
            i{
              color: rgba(255, 255, 255, 0.5);
              font-size:28px;
              line-height: 29px;
              font-weight: 500;
              }
          }
        }
      }
      .message{
        background: #fff;
        margin: 0 30px 20px;
        border-radius: 16px;
        display: flex;
        justify-content:space-between;
        padding: 50px 60px 40px;
        li{
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 28px;
          color: #333;
          font-weight: 500;
          span{
            margin-bottom: 20px;
          }
          i{color: #666;}
        }
      }
      .functionList{
        margin: 0 30px 0;
        padding: 50px 60px 40px;
        background: #fff;
        border-radius: 16px;
        display: flex;
        justify-content: space-between;
        li{
          display: flex;
          flex-direction: column;
          align-items: center;
          img{width: 50px;height: 50px;margin-bottom: 20px}
          span{
            font-size: 28px;
          }
        }
      }
    }
  }
</style>
